import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { searchStore, selectSearchTotals } from '~/modules/stores/searchStore';
import { GA4SearchClickEvent, GtmEventType } from './gtmEventType';

export class GtmSearchClickType extends GtmEventType {
    canHandle(event: any): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK &&
            (event.elementType === 'button' || event.elementType === 'filter') &&
            !!event.keyword
        );
    }

    getBody(event: any): GA4SearchClickEvent {
        return this.ga4GetBody(event);
    }

    getResultCounts(keyword: string): {
        search_result_count?: number;
        consultant_results?: number;
        app_results?: number;
        agent_results?: number;
    } {
        const totals = selectSearchTotals(searchStore.getState(), keyword);
        return {
            app_results: totals?.apps || 0,
            consultant_results: totals?.consultants || 0,
            agent_results: totals?.agents || 0,
            search_result_count:
                (totals?.apps || 0) +
                (totals?.consultants || 0) +
                (totals?.agents || 0) +
                (totals?.slack || 0) +
                (totals?.externalAgents || 0),
        };
    }

    ga4GetBody(event: any): GA4SearchClickEvent {
        return {
            event: event.sortLabel ? 'custEv_sortBy' : 'custEv_contentClick',
            click_text: event.button?.callToAction?.name || event.button?.callToAction?.label || event.value,
            element_type: event.sortLabel ? 'sort' : 'button',
            search_term: event.keyword,
            search_type: 'site',
            search_category: 'all',
            ...this.getResultCounts(event.keyword),
        };
    }
}
